module.exports = __webpack_public_path__ + "static/media/trash.7352ce76.svg";